import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 12l-2 .5a6 6 0 0 1 -6.5 -6.5l.5 -2l8 8","key":"svg-0"}],["path",{"d":"M20 12a8 8 0 1 1 -8 -8","key":"svg-1"}]]

/**
 * IconSticker
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3RpY2tlciIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjAgMTJsLTIgLjVhNiA2IDAgMCAxIC02LjUgLTYuNWwuNSAtMmw4IDgiIC8+CiAgPHBhdGggZD0iTTIwIDEyYTggOCAwIDEgMSAtOCAtOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/sticker
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSticker = createReactComponent('outline', 'sticker', 'Sticker', __iconNode);

export default IconSticker;